export default __webpack_public_path__ + "static/media/avatarImage.1e29e709.png";